var _g, _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFloodSensorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 54,
    viewBox: "0 0 47 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_4943)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.7743 7.56014C32.4427 4.22855 28.0114 2.3978 23.3019 2.3978C18.5859 2.3978 14.161 4.22855 10.8295 7.56014C7.49787 10.8917 5.66064 15.3231 5.66064 20.0326C5.66064 29.5616 14.6721 37.4927 19.5175 41.7494C20.1903 42.3445 20.766 42.8556 21.2318 43.2825C21.814 43.826 22.5579 44.0977 23.3019 44.0977C24.0458 44.0977 24.7898 43.826 25.3655 43.2825C25.8313 42.8556 26.4135 42.3445 27.0863 41.7494C31.9252 37.4927 40.9367 29.5616 40.9367 20.0326C40.9367 15.3231 39.1059 10.8917 35.7743 7.56014Z",
    fill: "#0A6543",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 22.9256
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.6678 12.7685L27.2278 12.8271L27.3693 13.889L27.8093 13.8304C28.3444 13.7594 28.8972 13.9064 29.326 14.2345C29.755 14.5626 30.0414 15.0575 30.1129 15.5926L30.1715 16.0326L31.2335 15.8912L31.1749 15.4511C31.0663 14.6362 30.6297 13.8828 29.9768 13.3833C29.3242 12.8842 28.4828 12.66 27.6678 12.7685Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4244 15.7327L33.4861 15.5898L33.4686 15.4618C33.2672 13.9498 32.49 12.6073 31.2785 11.6806C30.067 10.7539 28.5681 10.3547 27.0568 10.5563L26.928 10.5732L27.0679 11.6353L27.1975 11.6185C28.4255 11.4549 29.6439 11.7792 30.6277 12.5317C31.6115 13.2843 32.2437 14.3749 32.407 15.6039L32.4244 15.7327Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4617 9.37055C29.0674 9.33554 30.6541 9.8537 31.93 10.8297C33.2056 11.8054 34.121 13.2012 34.5077 14.7603L34.6887 15.4897L35.729 15.2319L35.5478 14.5023C35.1033 12.708 34.0493 11.1011 32.5811 9.97802C31.113 8.85528 29.286 8.25892 27.4382 8.29903L26.6863 8.31558L26.7097 9.3871L27.4617 9.37055Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2916 14.7702C18.5652 14.7702 14.7197 18.6158 14.7197 23.3421C14.7197 28.0685 18.5653 31.914 23.2916 31.914C28.018 31.914 31.8635 28.0684 31.8635 23.3421C31.8635 18.6157 28.0179 14.7702 23.2916 14.7702ZM21.6843 29.7712H20.6129V28.6998H21.6843V29.7712ZM23.8273 29.7712H22.7559V28.6998H23.8273V29.7712ZM25.9704 29.7712H24.899V28.6998H25.9704V29.7712ZM23.472 27.0924H23.1104C21.7309 27.0924 20.6122 25.9737 20.6122 24.5942C20.6122 24.1259 20.744 23.6674 20.992 23.2705L23.291 19.5921L25.5899 23.2705C25.8379 23.6674 25.9697 24.1261 25.9697 24.5942C25.9703 25.9739 24.8517 27.0924 23.472 27.0924ZM27.3392 29.6812L26.7451 28.7897C28.609 27.5473 29.7212 25.4685 29.7212 23.229C29.7212 19.7461 26.8882 16.913 23.4052 16.913H23.1792C19.6962 16.913 16.8632 19.746 16.8632 23.229C16.8632 25.4686 17.9754 27.5471 19.8393 28.7897L19.2437 29.6812C17.0815 28.24 15.7909 25.8276 15.7909 23.2291C15.7909 19.1552 19.105 15.8417 23.1784 15.8417H23.4044C27.4783 15.8417 30.7918 19.1557 30.7918 23.2291C30.792 25.8269 29.5015 28.2394 27.3392 29.6812H27.3392Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_4943",
    x: 0.160645,
    y: 0.897797,
    width: 46.2759,
    height: 52.6999,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_4943"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_4943",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloodSensorIcon);
export default __webpack_public_path__ + "static/media/floodSensorIcon.ff5e6880e2ea732f37b7ff015de2730f.svg";
export { ForwardRef as ReactComponent };